import {useTranslate} from '@tolgee/react'
import {Button, ButtonGroup, VStack} from '@chakra-ui/react'
import {useAppForm} from '@cypro/ui/integrations/form'
import {GlobalDoseReductionSchema} from '@/modules/patients/schemas'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {toaster} from '@cypro/ui/toaster'
import {dialog} from '@/modules/layout'

type GlobalDoseReductionTabProps = {
  patientId: string
}

function onClose() {
  dialog.close('add-dose-reduction', true)
}

export function GlobalDoseReductionTab({patientId}: GlobalDoseReductionTabProps) {
  const {t} = useTranslate('dose-reduction')

  const zero = useZero()
  const form = useAppForm({
    defaultValues: {
      patientId: patientId,
    } as GlobalDoseReductionSchema,
    validators: {
      onSubmit: GlobalDoseReductionSchema,
    },
    onSubmit(props) {
      applyDoseReduction(props.value)
      onClose()
    },
  })

  function onSubmit() {
    form.handleSubmit()
  }

  function applyDoseReduction(payload: Parameters<typeof zero.mutators.patients.saveDoseReduction>[0]) {
    return zero.attemptMutation(zero.mutators.patients.saveDoseReduction(payload), async mutation => {
      const data = await mutation.server
      if (!data) return

      toaster.success({title: t('success', {ns: 'common'}), description: t('applied_success')})
      form.reset()
    })
  }

  return (
    <VStack align="stretch" gap="4">
      <form.AppField name="doseReduction">
        {field => <field.NumberInput label={t('reduce_all')} placeholder="20" min={0} max={100} />}
      </form.AppField>
      <ButtonGroup justifyContent="flex-end" marginTop="4">
        <Button variant="outline" colorPalette="gray" onClick={onClose}>
          {t('cancel', {ns: 'common'})}
        </Button>
        <Button size="sm" colorPalette="cyan" onClick={onSubmit}>
          {t('apply', {ns: 'common'})}
        </Button>
      </ButtonGroup>
    </VStack>
  )
}
